import home from '@/pages/home/router'
import user from '@/pages/user/router'

export default [
  {
    path: '/',
    name: 'index',
    component: () => import('./index')
  },
  {
    path: '/admin',
    name: 'admin',
    redirect: {
      name: 'admin-index'
    },
    component: () => import('@/layout/admin'),
    children: (pre => [
      ...home
    ])()
  },
  {
    path: '/my',
    name: 'my',
    redirect: {
      name: 'my-index'
    },
    component: () => import('@/layout/my'),
    children: (pre => [
      ...user
    ])()
  }
]
